function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useState } from 'react';
import { InputContainer, InputWrapper, InputContent, InputStyled, InputLabel, HelperText, Error, Placeholder, ErrorContainer, InputAddon } from "./styled";
import { positionEnum } from "../../enums/positionEnum";
export var INPUT_WRAPPER_TEST_ID = 'INPUT_WRAPPER_TEST_ID';
export var INPUT_ADDON_AFTER_TEST_ID = 'INPUT_ADDON_AFTER_TEST_ID';
export var INPUT_ADDON_BEFORE_TEST_ID = 'INPUT_ADDON_BEFORE_TEST_ID';
export var EnumInputTypes;

(function (EnumInputTypes) {
  EnumInputTypes["text"] = "text";
  EnumInputTypes["tooltip"] = "tooltip";
})(EnumInputTypes || (EnumInputTypes = {}));

var Input = forwardRef(function (props, ref) {
  var name = props.name,
      className = props.className,
      value = props.value,
      defaultValue = props.defaultValue,
      error = props.error,
      label = props.label,
      helperText = props.helperText,
      disabled = props.disabled,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      before = props.before,
      after = props.after,
      readOnly = props.readOnly,
      _props$size = props.size,
      size = _props$size === void 0 ? 'normal' : _props$size,
      required = props.required,
      placeholder = props.placeholder,
      testId = props.testId,
      _props$errorType = props.errorType,
      errorType = _props$errorType === void 0 ? EnumInputTypes.text : _props$errorType,
      otherProps = _objectWithoutProperties(props, ["name", "className", "value", "defaultValue", "error", "label", "helperText", "disabled", "type", "onChange", "onFocus", "onBlur", "before", "after", "readOnly", "size", "required", "placeholder", "testId", "errorType"]);

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      changeValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      changeFocus = _useState4[1];

  var controlled = typeof value !== 'undefined';
  var finalValue = controlled ? value : stateValue;
  var id = "input_".concat(name);

  var onFocusHandler = function onFocusHandler(e) {
    if (onFocus) {
      onFocus(e);
    }

    changeFocus(true);
  };

  var onBlurHandler = function onBlurHandler(e) {
    if (onBlur) {
      onBlur(e);
    }

    changeFocus(false);
  };

  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) {
      onChange(e);
    }

    if (!controlled) {
      changeValue(e.target.value);
    }
  };

  var isShowPlaceholder = placeholder && !stateValue && !value;
  return React.createElement(InputContainer, {
    className: className,
    disabled: disabled
  }, label && React.createElement("label", {
    htmlFor: id
  }, React.createElement(InputLabel, {
    size: size
  }, label)), React.createElement(ErrorContainer, null, React.createElement(InputWrapper, _extends({
    "data-testid": INPUT_WRAPPER_TEST_ID,
    error: !!error
  }, {
    size: size,
    focused: focused,
    disabled: disabled
  }), before && React.createElement(InputAddon, {
    marginSize: 2,
    "data-testid": INPUT_ADDON_BEFORE_TEST_ID
  }, before), React.createElement(InputContent, null, React.createElement(InputStyled, _extends({
    "data-testid": testId,
    value: finalValue,
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    onChange: onChangeHandler
  }, _objectSpread({}, otherProps, {
    name: name,
    disabled: disabled,
    id: id,
    type: type,
    readOnly: readOnly,
    required: required,
    ref: ref
  }))), isShowPlaceholder && React.createElement(Placeholder, {
    required: !!required
  }, placeholder)), after && React.createElement(InputAddon, {
    "data-testid": INPUT_ADDON_AFTER_TEST_ID,
    position: positionEnum.right,
    marginSize: 2
  }, after)), error && typeof error === 'string' && React.createElement(Error, {
    errorType: errorType,
    size: size
  }, error)), !error && helperText && React.createElement(HelperText, {
    size: size
  }, helperText));
});
Input.displayName = 'Input';
export default Input;